import { SyntheticEvent } from 'react';
import { Text } from '@comicrelief/component-library';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import { UrlOverridesState } from '@/services/urlOverrides/urlOverridesSlice';
import { useCartContext } from '@/services/cart/CartContext';
import { JourneyName } from '@/services/journeys/types';
import { JOURNEY_TYPES } from '@/constants/constants';
import { Wrapper, ArrowIcon, StyledButton } from './StepBack.style';

interface StepBackProps {
  testId?: string;
  isFirstJourneyStep?: boolean;
  urlOverrides?: UrlOverridesState;
  currentJourney?: JourneyName;
  successUrl?: string;
}

function StepBack({
  testId = 'goBackButton', isFirstJourneyStep = false, urlOverrides = {}, currentJourney = undefined, successUrl = undefined
}: StepBackProps) {
  const journeyNavigate = useJourneyNavigate();
  const { validateWidgetJourney } = useCartContext();
  const { DIRECT } = JOURNEY_TYPES;

  const handleBackClick = (event: SyntheticEvent) => {
    event.preventDefault();

    // If the user has been forwarded *directly* onto the first step of the
    // selected journey (rather than the very first page), bounce them back to CRcom rather than the Journey Select page:
    if (isFirstJourneyStep && validateWidgetJourney(urlOverrides)) {
      // All verified by validateWidgetJourney, so we can reliably use them here:
      const {
        siteUrlOverride, affiliateOverride, amountOverride, rowIdOverride
      } = urlOverrides;

      const forwardingURL = `${siteUrlOverride}?affiliate=${affiliateOverride}&amount=${amountOverride}&currency=GBP&rowID=${rowIdOverride}`;

      window.location.replace(forwardingURL);
      // This'll let the user navigate back to the referring URL on the first step of a Direct payment journey:
    } else if (isFirstJourneyStep && currentJourney === DIRECT && successUrl) {
      const thisUrl = new URL(successUrl);
      // Strip out params used by CRcom in a 'success' scenario; we just need the path:
      const forwardingURL = `${thisUrl.origin}${thisUrl.pathname}`;
      window.location.replace(forwardingURL);
    } else {
      journeyNavigate('back');
    }
  };

  return (
    <Wrapper>
      <StyledButton
        onClick={handleBackClick}
        type="button"
        data-test={testId}
      >
        <ArrowIcon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </ArrowIcon>
        <Text tag="p" family="Montserrat" weight="bold" size="s">Go back</Text>
      </StyledButton>
    </Wrapper>
  );
}

export default StepBack;
